import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-custact-members',
  templateUrl: './custact-members.component.html',
  styleUrls: ['./custact-members.component.css']
})
export class CustactMembersComponent implements OnInit {
    public custactNo;

    public webPage;

    public itemsListMembers: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.custactNo = this.stateService.getStateParams()['custact_no'];
        this.webPage = this.stateService.getCurrentName();
    }

    private async loadMembers() {
        if (!!this.custactNo) {
            this.itemsListMembers = await this.datatask.Post(92, { custact_no: this.custactNo });
        }
    }

    private async init() {
        this.loadMembers();
    }

    ngOnInit() {
        this.init();
    }
}
